import React, { useEffect, useState } from "react";
import { GLOBAL_IMAGES, HEADER } from "../../assets/asset";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toggleMute } from "../../store/slice/muteSlice";
import AIModal from "../HandleAIQuestions/AIModal";

const Header = ({ onLogout, showDemo, showLessonContent }) => {
  const { user } = useSelector((state) => state.user);
  const { isMuted } = useSelector((state) => state.mute);
  const { showKnowledge } = useSelector((state) => state.profile);
  const [showAboutInfo, setShowAboutInfo] = useState(false);
  const [showAIModal, setShowAIModal] = useState(false);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  
  const handleAIClick = () => {
    // Open the modal first
    setShowAIModal(true);
  };
  
  const handleGetStarted = () => {
    // Close the modal and navigate to AIHandler
    setShowAIModal(false);
    const yearId = user?.YearId || "7";
    navigate(`/AIHandler/${yearId}`);
  };

  useEffect(() => {
    if (showAboutInfo) {
      const timeoutID = setTimeout(() => {
        setShowAboutInfo(false);
      }, 3000);
      return () => clearTimeout(timeoutID);
    }
  }, [showAboutInfo]);

  const handleAboutButtonClick = () => {
    setShowAboutInfo(true);
  };

  const toggleSound = () => {
    dispatch(toggleMute());
  };

  return (
    <>
      <div className="flex justify-between items-center w-full py-4 px-6">
        <img
          src={GLOBAL_IMAGES.dingo}
          alt="MathDingo Logo"
          className="w-32 h-32"
        />

        {/* Middle Section - Icons */}
        <div className="flex items-center space-x-6">
          <Link to="/report">
            <img src={HEADER.ReportCard} alt="Report Card" className="h-20" />
          </Link>

          <Link to="/leaderboard">
            <img src={GLOBAL_IMAGES.medal} alt="Leaderboard" className="h-20" />
          </Link>

          <img
            src={isMuted ? HEADER.muteSound : HEADER.Sound}
            onClick={toggleSound}
            className="h-20 cursor-pointer"
          />

          <div className="relative">
            <img
              src={HEADER.About}
              alt="About"
              className="h-20"
              onClick={handleAboutButtonClick}
            />

            {showAboutInfo && (
              <div
                className={`absolute bg-primary-brown p-2 rounded-lg text-sm right-0 text-white w-96 bubble`}
              >
                <p className="">
                  Stay tuned for exciting updates ahead! Our syllabus follows the
                  VIC curriculum for top-quality education.
                </p>
              </div>
            )}
          </div>

          {/* User Profile Icon */}
          <Link to={`/settings`}>
            <img
              src={user?.profilephotos}
              alt="User Profile"
              className={`h-16 ${showDemo === 1 ? "relative z-40" : "null"}`}
            />
          </Link>

          {/*  on click open AI Modal first */}
          <img
            src={HEADER.AI}
            alt="AI Assistant Icon"
            className={`h-32 cursor-pointer ${
              showDemo === 2 || showDemo === 1 || showLessonContent
                ? "z-10"
                : "z-30"
            }`}
            onClick={handleAIClick}
          />
        </div>
      </div>
      
      {/* AI Modal */}
      <AIModal 
        isOpen={showAIModal} 
        onClose={() => setShowAIModal(false)} 
        onGetStarted={handleGetStarted} 
      />
    </>
  );
};

export default Header;
